export { default as buildIconUrl } from './build-icon-url'; // Export the icon details for cases where we want to validate props against
// the keys etc. Note that the manifest is created when the package is built.
// eslint-disable-next-line

export default require('./manifest.json').icons;